// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quick-animations-groups,.quick-animations-types{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}.quick-animations-types .quick-animation-type{margin-right:.25rem;height:2rem;-ms-flex:none;flex:none;font-size:.875rem;font-weight:600;border-radius:.25rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.quick-animation-type:focus{outline:0}.quick-animation-group{width:4rem;height:1.5rem;font-size:.75rem;-ms-flex:none;flex:none}", ""]);
// Exports
module.exports = exports;
